import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=75cd1086&scoped=true&"
import script from "./Send.vue?vue&type=script&lang=js&"
export * from "./Send.vue?vue&type=script&lang=js&"
import style0 from "./Send.vue?vue&type=style&index=0&id=75cd1086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd1086",
  null
  
)

export default component.exports